module.exports = __webpack_public_path__ + "images/avatars/ppl_edward.png";